module.exports = __webpack_public_path__ + "static/media/signuptitle.026da3ee.svg";